import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as s, createStaticVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGmail",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function p(t, e, l, h, f, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--gmail"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Gmail",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...e[0] || (e[0] = [
    n('<path d="M6.545 20.004v-7.727L4.15 10.084 2 8.867v9.773c0 .755.611 1.364 1.364 1.364h3.181z" fill="#4285F4"></path><path d="M17.454 20.004h3.182c.755 0 1.364-.612 1.364-1.364V8.868l-2.434 1.393-2.111 2.016v7.727z" fill="#34A853"></path><path d="m6.545 12.277-.326-3.02.326-2.89L12 10.458l5.454-4.09.365 2.733-.364 3.176L12 16.367l-5.455-4.09z" fill="#EA4335"></path><path d="M17.454 6.367v5.91L22 8.867V7.05c0-1.686-1.925-2.647-3.273-1.636l-1.273.954z" fill="#FBBC04"></path><path d="m2 8.867 2.09 1.568 2.455 1.841V6.368l-1.272-.954C3.923 4.4 2 5.363 2 7.049v1.818z" fill="#C5221F"></path>', 5)
  ])], 10, m);
}
const z = /* @__PURE__ */ o(c, [["render", p]]);
export {
  z as default
};
//# sourceMappingURL=gmail.js.map
